import styled from 'styled-components';
import { Button, Flex } from '@beamery/lib-ds-components';
import { maxFormWidth } from 'candidate-facing-components';

export const CloseButton = styled(Button)`
  border-radius: 50%;
  width: 48px;
  height: 48px;
`;
CloseButton.defaultProps = {
  variant: 'secondary',
};

export const Header = styled(Flex)`
  margin-bottom: ${({ theme }) => theme.space.x4};
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;
Header.defaultProps = {
  justify: 'flex-end',
};

export const ContainerWrapper = styled.div`
  display: flex;
  flex: 0 1 100%;
  flex-direction: column;
  align-items: center;
`;

export const FormWrapper = styled.div<{ $enableScrollbar: boolean }>`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.space.x4};
  padding-bottom: ${({ theme, $enableScrollbar }) =>
    $enableScrollbar ? theme.space.x10 : theme.space.x4};
  background-color: ${({ theme }) => theme.colors.backgrounds.onGray};
  border-radius: ${({ theme }) => theme.radii.x2};
  position: relative;
  width: 100%;
  max-width: ${({ theme }) =>
    `calc(${maxFormWidth} + ${theme.space.x4} + ${theme.space.x4})`};
  flex: 1 0 300px;
  max-height: 100%;
`;

export const ScrollableContainer = styled.div<{ $enableScrollbar: boolean }>`
  padding: 0
    ${({ theme, $enableScrollbar }) => ($enableScrollbar ? theme.space.x4 : 0)};
  overflow-y: ${({ $enableScrollbar }) =>
    $enableScrollbar ? 'auto' : 'unset'};
`;
